<script lang="ts">
    import { WISHLIST_ICONS } from "@apps/wishlist/constants/constants";
    import { WishlistsStorefrontValuesBrandingEntity } from "@apps/wishlist/entities/WishlistsStorefrontValuesBrandingEntity";

    import Icon from "@components/Icon.svelte";

    export let iconSettings: WishlistsStorefrontValuesBrandingEntity["wishlistIconSettings"];
    export let isFilled: boolean | undefined;
    export let width: string | number = 16;
    export let height: string | number = 16;

    const iconType = iconSettings.iconType;
    const isCustomIconEnabled = iconSettings.customIcons.isEnabled;
    const customFilledImage = isCustomIconEnabled
        ? iconSettings.customIcons.filledImage
        : null;

    const customOutlinedImage = isCustomIconEnabled
        ? iconSettings.customIcons.outlinedImage
        : null;
</script>

{#if isFilled}
    {#if customFilledImage}
        <img {width} {height} src={customFilledImage} alt="FilledIcon" />
    {:else}
        <Icon viewBox="0 0 24 24" {width} {height} class="gw-wl-icon">
            <svelte:component this={WISHLIST_ICONS[iconType].filled} />
        </Icon>
    {/if}
{:else if customOutlinedImage}
    <img {width} {height} src={customOutlinedImage} alt="OutlinedIcon" />
{:else}
    <Icon viewBox="0 0 24 24" {width} {height} class="gw-wl-icon">
        <svelte:component this={WISHLIST_ICONS[iconType].outlined} />
    </Icon>
{/if}

<style lang="postcss" global>
    .gw-wl-icon {
        color: var(--gw-wl-wishlistIconSettings-heartColor);
    }
</style>
